import React from "react"

import Layout from "../components/layout"
import Snippet from "../components/snippet"
import Card from "../components/card"

import layoutStyle from "../components/layout.module.css"

const InfoPage = () => (
	<Layout
		meta={{
			title: "Infos",
			description:
				"Locations of Accento's talks, trainings, and afterparty and quick dive into the dirty topic.",
			keywords: "location",
			path: "/info",
		}}
		wide
	>
		<Snippet id="info-intro" />
		<Snippet id="info-locations" />
		<Snippet id="info-hotels" />
		<Snippet id="info-quick-dirty" />
		<Snippet id="info-jcon" />

		<div>
			<Snippet id="info-partner" />
			<div className={layoutStyle.cards}>
				<Card size="medium" imageSlug="dev-specialists" imageLink="https://www.dev-specialists.com/" />
				<Card size="medium" imageSlug="cjt" imageLink="https://www.cjt.de/" />
				<Card size="medium" imageSlug="diva-e" imageLink="https://www.diva-e.com/en/" />
				<Card size="medium" imageSlug="chrono-24" imageLink="https://www.chrono24.com/" />
				<Card size="medium" imageSlug="synyx" imageLink="https://synyx.de/" />
				<Card size="medium" imageSlug="andrena" imageLink="https://www.andrena.de/" />
				<Card size="medium" imageSlug="retest" imageLink="https://retest.de/" />
				<Card size="medium" imageSlug="exxeta" imageLink="https://www.exxeta.com/en/home/" />
			</div>
			<h3 style={{textAlign: "center"}}>Media Partners</h3>
			<div className={layoutStyle.cards}>
				<Card size="medium" imageSlug="cyberforum" imageLink="https://www.cyberforum.de/" />
				<Card size="medium" imageSlug="dpunkt" imageLink="https://www.dpunkt.de/" />
				<Card size="medium" imageSlug="mein-ka" imageLink="https://meinka.de/" />
				<Card size="medium" imageSlug="stickermule" imageLink="http://stickermule.com/supports/accento19-sponsorship" />
				<Card size="medium" imageSlug="manning" imageLink="https://www.manning.com/" />
			</div>
		</div>

		<Snippet id="info-disy" />
	</Layout>
)

export default InfoPage
